<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/odkbav/tc-custom/9781449461362.jpg?1708400178173" alt="This image is the cover for the book Serenity Prayers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Serenity Prayers
      </h1>
      <p class="bookDescription body article font2">
        <i>Serenity Prayers</i> is a lovely and timeless collection of prayers, prose, and poems that leaves readers feeling relaxed, peaceful, hopeful, and encouraged. It's a thoughtful resource for facing everyday challenges.<br/><br/> Excerpt from the book:<br/> "A Clear Midnight<br/> This is thy hour O Soul, thy free flight into the wordless,<br/> Away from books, away from art, the day erased, the lesson done,<br/> Thee fully forth emerging, silent, gazing, pondering the themes thou lovest best,<br/> Night, sleep, death and the stars."<br/> --Walt Whitman (1819-1892)<br/><br/> Features selections from Mitch Albom, Emily Dickinson, William Penn, Rumi, Carl Sandburg, Henry David Thoreau, Walt Whitman, and William Butler Yeats.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        June Cotner
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?048e3680